import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

import { fixAccessibilityRemoveIdsFromDuplicateSlides } from '../../../../global/js/helpers';

function sliderImages() {
    Swiper.use([Autoplay, Navigation, Pagination]);

    new Swiper('.js-slider-swiper-images', {
        loop: true,
        speed: 600,
        autoplay: false,
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            prevEl: '.js-slider-swiper-images-btn-prev',
            nextEl: '.js-slider-swiper-images-btn-next',
        },
        pagination: {
            el: '.js-slider-swiper-image-pagination',
            type: 'bullets',
            clickable: true,
        },
        on: {
            init: (e) =>
                setTimeout(
                    () => fixAccessibilityRemoveIdsFromDuplicateSlides(e),
                    1000,
                ),
        },
    });
}

export default sliderImages;
